export default __webpack_public_path__ + "static/media/Lexil - Trou blanc.cca287c6.mp3";